import { MOBILEHOST } from '@/apis/host';

export const BILLING_CYCLE_TYPE = {
  MONTHLY: 'monthly',
  YEARLY: 'annual',
  DAILY: 'daily'
};
export const PLAN_TYPE = {
  FREE: 'Free',
  PRO: 'Pro',
  TEAM: 'Team'
};

// 试用期天数
export const TRIAL_PERIOD_DAYS = 15;

/** 会员商品 ID（与支付页 / 会员专区一致）：专业版、机构版 */
export const MEMBER_PRO_GOODS_ID = '10002';
export const MEMBER_ORG_GOODS_ID = '10003';

/**
 * 个人中心 / 头像浮层等多条会员权益的展示顺序。
 * 新增类型（如进门会员）请将对应 goodsId 追加到数组；未列入的权益按 goodsName 排在末尾。
 */
export const MEMBER_EQUITY_DISPLAY_GOODS_IDS = [MEMBER_PRO_GOODS_ID, MEMBER_ORG_GOODS_ID];

export const AGREEMENT_URL = `${MOBILEHOST}/mobile/agreement/membership`;
export const RECHARGE_AGREEMENT_URL = `${MOBILEHOST}/mobile/agreement/niuCoinRecharge`;
/** 进门助手（进门小悦）企业微信获客链接 */
export const WECHAT_JINMEN_ASSISTANT_URL = 'https://work.weixin.qq.com/ca/cawcdeba87e2ddc782';
